import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAppMaintenance, IMaintenanceState } from "./maintenanceTypes";

const initialState: IMaintenanceState = {
  data: null,
};

export const maintenanceSlice = createSlice({
  name: "@@hd/MAINTENANCE",
  initialState,
  reducers: {
    getMaintenanceCheck: (
      _state: IMaintenanceState,
      _action: PayloadAction<any>
    ) => {},
    getMaintenanceCheckSuccess: (
      state: IMaintenanceState,
      action: PayloadAction<IAppMaintenance>
    ) => {
      state.data = action.payload;
    },
    getMaintenanceCheckFailure: (
      state: IMaintenanceState,
      _action: PayloadAction<any>
    ) => {
      state.data = null;
    },
  },
});

export const { actions, reducer } = maintenanceSlice;
